import SOCategoriesPanel from './SOCategoriesPanel';

export default SOCategoriesPanel;
